window.serializeFormData = function ($form) {
    this.console.log($form);
    var unindexed_array = $form.serializeArray();
    var indexed_array = {};

    $.map(unindexed_array, function (n, i) {
        indexed_array[n['name']] = n['value'];
    });

    return indexed_array;
}

window.onload = function () {

    // for some reasoon the collapse events don't work
    var navbar = document.getElementById('wrapper-navbar');
    var toggler = navbar.querySelector('#navbar-toggler');
    var navbarNavDropdown = document.getElementById('navbarNavDropdown');

    window.addEventListener('scroll', function () {
        //console.log(window.scrollY);
        if (window.scrollY > 0) {
            debounce(navbar.classList.add('sticky'), 100);
        } else {
            debounce(navbar.classList.remove('sticky'), 100);
        }
    });
    
    toggler.addEventListener('click', function () {
        console.log(navbarNavDropdown.classList);
        if (navbarNavDropdown.classList.contains('show'))
            setTimeout(function () {
                navbar.classList.remove('nav-on');
            }, 200);
        else
            navbar.classList.add('nav-on');
    });

    function getChildren(n, skipMe){
        var r = [];
        for ( ; n; n = n.nextSibling ) 
           if ( n.nodeType == 1 && n != skipMe)
              r.push( n );        
        return r;
    };
    
    function getSiblings(n) {
        return getChildren(n.parentNode.firstChild, n);
    }

    var closeBtnTrap = document.getElementById('closeBtnTrap');
    var loopBtnTrap = document.getElementById('loopBtnTrap');

    var isAndroid = /(android)/i.test(navigator.userAgent);
    
    var navBarSiblings = getSiblings(document.getElementById('wrapper-navbar'));

    navbarNavDropdown.addEventListener('shown.bs.collapse', (e) => {

        if(!isAndroid) {
            closeBtnTrap.style.display = 'inline';
            loopBtnTrap.style.display = 'inline';
        }

        // navBarSiblings.forEach((item) => {
        //     item.setAttribute('tabindex', '-1');
        //     item.setAttribute('aria-hidden', 'true');
        // })
    });
    
    navbarNavDropdown.addEventListener('hidden.bs.collapse', (e) => {
        closeBtnTrap.style.display = 'none';
        loopBtnTrap.style.display = 'none';
        // navBarSiblings.forEach((item) => {
        //     item.setAttribute('tabindex', '0');
        //     item.setAttribute('aria-hidden', 'false');
        // })
    });

    closeBtnTrap.addEventListener('focus', e => {
        var el = e.target.nextElementSibling;
        if (navbarNavDropdown.classList.contains('show'))
            document.getElementById('contact-btn').focus();
    });

    document.getElementById('loopBtnTrap').addEventListener('focus', e => {
        navbar.querySelector('.custom-logo-link').focus();
    });

    // move the cookie bar to the top
    var cookieNotice = document.getElementById('cookie-law-info-bar');
    if(cookieNotice != null) {
        document.body.insertBefore(cookieNotice, document.body.firstChild);
        document.getElementById('cookie_action_close_header').classList.add('btn','btn-primary');
    }
};

document.addEventListener('wpcf7mailsent', function (event) {
    location = '/thank-you/';
}, false);

function debounce(func, wait, immediate) {
    var timeout;
    return function () {
        var context = this, args = arguments;
        var later = function () {
            timeout = null;
            if (!immediate) func.apply(context, args);
        };
        var callNow = immediate && !timeout;
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
        if (callNow) func.apply(context, args);
    };
};

jQuery(function ($) {

    $.validator.addMethod(
        "regex_phone",
        function (value, element, regexp) {
            var re = new RegExp(regexp);
            return this.optional(element) || re.test(value);
        },
        "Incorrect phone format"
    );
    
    $.validator.addMethod(
        "regex_email",
        function (value, element, regexp) {
            var re = new RegExp(regexp);
            return this.optional(element) || re.test(value);
        },
        "Incorrect email format"
    );

    $(".wpcf7-form-control").prop('required', true);
    $(".wpcf7-form").removeAttr('novalidate');
    $(".wpcf7-form").removeClass('wpcf7-form form contact-form');
    $(".wpcf7-form .wpcf7-form-control").removeClass('wpcf7-form-control wpcf7-text wpcf7-validates-as-required')
    $('form.validate').each(function () {
        $(this).validate({
            onfocusout: function (element) {
                this.element(element);
                },
            rules: {
                password: {
                    required: true,
                    regex: /^(?=.*[A-Za-z])(?=.*\d).{8,}$/
                },
                password_1: {
                    regex: /^(?=.*[A-Za-z])(?=.*\d).{8,}$/
                },
                account_password: {
                    regex: /^(?=.*[A-Za-z])(?=.*\d).{8,}$/
                },
                password_again: {
                    equalTo: "#registration_password"
                },
                password_2: {
                    equalTo: "#password_one"
                },
                'your-email': {
                    regex_email: /^([a-zA-Z0-9_.-])+@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/,
                },
                email: {
                    regex_email: /^([a-zA-Z0-9_.-])+@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/,
                },
                username: {
                    regex_email: /^([a-zA-Z0-9_.-])+@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/,
                },
                user_login: {
                    regex_email: /^([a-zA-Z0-9_.-])+@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/,
                },
                billing_email: {
                    regex_email: /^([a-zA-Z0-9_.-])+@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/,
                },
                shipping_email: {
                    regex_email: /^([a-zA-Z0-9_.-])+@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/,
                },
                phone: {
                    regex_phone: /^\+?[\d\ ]+$/
                },
                billing_phone: {
                    regex_phone: /^\+?[\d\ ]+$/
                },
                shipping_phone: {
                    regex_phone: /^\+?[\d\ ]+$/
                },
                day: 'isValidBirthDay',
                month: 'isValidBirthMonth',
                year: 'isValidBirthYear',
                day_1: 'isValidBirthDay',
                month_1: 'isValidBirthMonth',
                year_1: 'isValidBirthYear',
            },
            messages: {
                pasword: {
                    required: "Please enter password",
                    minlength: "Password needs to be at least 6 characters long."
                },
                password_again: {
                    equalTo: "The passwords you entered do not match."
                },
                pasword_1: {
                    required: "Please enter password",
                    minlength: "Password needs to be at least 6 characters long."
                },
                password_2: {
                    equalTo: "The passwords you entered do not match."
                },
                birth_day: 'error',
                birth_month: 'error',
                birth_year: 'error',
            },
            errorPlacement: function (error, element) {
                if (element.parent('.input-group').length) {
                    error.insertAfter(element.parent());      // radio/checkbox?
                } else if (element.next('span').hasClass('select2')) {
                    error.insertAfter(element.next('span'));  // select2
                } else {
                    error.insertAfter(element);               // default
                }
            }
        });
    });
    
    // Array.prototype.forEach.call(document.querySelectorAll('form.validate'), function (el, i) {
    //     console.log(el);
    //     var submitBtn = el.querySelector('input[type=submit]');
    //     submitBtn.addEventListener('click', function(e) {
    //         console.log(e.target);
    //         //var f = e.target.closest('form');
    //         $(el).validate();
    //         if (!$(el).valid())
    //             e.preventDefault();
    //     });  
    // });

    var hs_form_container = document.getElementById('hs_form');
    console.log(hs_form_container.querySelector('form'));
    
});
